import React from "react";
import { Link } from "react-router-dom";

function WebFooter() {
  return (
    <footer className="bg-dark text-white">
      <div className="container py-4 text-center">
        <div className="">
          <Link to="/" className="text-white me-3">Home</Link>
          <Link to="/about" className="text-white me-3">About</Link>
          <Link to="/login" className="text-white">Login</Link>
        </div>
        <p className="mb-0">&copy; {new Date().getFullYear()} DSCE College AIDS 2022-26 . All rights reserved.</p>
      </div>
    </footer>
  );
}

export default WebFooter;
